import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createServiceSubCategory = (_, params) => {
  return Api(endPoints.createServiceSubCategory, params, requestType.POST);
};

const getAllServiceSubCategory = () => {
  return Api(endPoints.getAllServiceSubCategory, null, requestType.GET);
};

const getAllServiceSubCategoryById = (id, name) => {
  return Api(
    `${endPoints.getAllServiceSubCategoryById}/${id}?name=${name}`,
    null,
    requestType.GET
  );
};

const updateServiceSubCategory = (id, params) => {
  return Api(
    `${endPoints.updateServiceSubCategory}/${id}`,
    params,
    requestType.PUT
  );
};

const deleteServiceSubCategory = (id) => {
  return Api(
    `${endPoints.deleteServiceSubCategory}/${id}`,
    null,
    requestType.DELETE
  );
};

export {
  createServiceSubCategory,
  getAllServiceSubCategory,
  getAllServiceSubCategoryById,
  updateServiceSubCategory,
  deleteServiceSubCategory,
};
